module.exports = __webpack_public_path__ + "img/Valoris.8fe85467.png";